/** @jsxImportSource @emotion/react */
import React from "react";
import { jsx, css } from "@emotion/react";
import { useEffect, useState, forwardRef } from "react";
import ClearIcon from "@mui/icons-material/Clear";
import Swal from "sweetalert2";
import axios from "axios";
import { useHistory } from "react-router-dom";
import Loading from "./Loading";
import Layout from "./Layout";
import { DataGrid } from "@mui/x-data-grid";
import AddIcon from "@mui/icons-material/Add";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import Slide from "@mui/material/Slide";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import { loginState, configState } from "../lib/State";
import log from "../lib/log";
import pr from "../lib/pr";
import MemberSearch from "./MemberSearch";
import {
  Select,
  MenuItem,
  AppBar,
  Toolbar,
  Typography,
  RadioGroup,
  Radio,
  FormControlLabel,
  FormLabel,
  InputAdornment,
} from "@mui/material";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import MobileDatePicker from "@mui/lab/MobileDatePicker";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import { ko } from "date-fns/locale";
import moment from "moment";
import ProductSearch from "./ProductSearch";
import { lightGreen } from "@mui/material/colors";

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

// 등록하기 팝업
function ItemEdit(props) {
  const { login, onClosePop, seq } = props;
  const token = localStorage.getItem("token");
  const [centers, setCenters] = useState([]);
  const [tcid, setTcid] = useState("");
  const [showMemberSearch, setShowMemberSearch] = useState(false);
  const [showProductSearch, setShowProductSearch] = useState(false);
  const [type, setType] = useState("CLASS"); //1
  const [name, setName] = useState(""); //2
  const [amount, setAmount] = useState(0); //3
  const [count, setCount] = useState(0); //4
  const [dtype, setDtype] = useState("2"); //4
  const [dcount, setDcount] = useState(0); //4
  const [is_show, setIsShow] = useState(""); //4
  const [pid, setPid] = useState("");
  const [originPrice, setOriginPrice] = useState(0);
  const [discountRate, setDiscountRate] = useState(0);
  const [season, setSeason] = useState(false);

  useEffect(() => {
    const value = Math.round(((originPrice - amount) / originPrice) * 100);
    if (isNaN(value)) return;
    setDiscountRate(value);
  }, [originPrice, amount]);

  const onSubmit = async () => {
    let result = await axios.post(
      configState.api + "/gympass_admin/item_edit",
      {
        token: token,
        cid: login.cid,
        level: login.level,
        mcd: login.mcd,
        tcid: tcid,
        type: type,
        name: name,
        amount: amount,
        count: count,
        dtype: dtype,
        dcount,
        dcount,
        is_show: is_show,
        seq: seq,
        origin_price: originPrice,
        discount_rate: discountRate,
        season: season ? "Y" : "N",
      }
    );
    if (result.data.success !== 1) {
      Swal.fire(result.data.msg);
      return;
    } else {
      Swal.fire({ title: "수정 되었습니다.", showCloseButton: true }).then(
        (result) => {
          onClosePop();
        }
      );
    }
  };

  const load_data = async () => {
    let result = await axios.post(configState.api + "/gympass_admin/item_one", {
      token: token,
      cid: login.cid,
      level: login.level,
      mcd: login.mcd,
      seq: seq,
    });
    if (result.data.success === 1) {
      setName(result.data.row.name);
      setType(result.data.row.type);
      setAmount(result.data.row.amount);
      setDcount(result.data.row.dcount);
      setDtype(result.data.row.dtype);
      setIsShow(result.data.row.is_show);
      setCount(result.data.row.pt_count);
      setPid(result.data.row.pid);
      setOriginPrice(result.data.row.origin_price);
      setDiscountRate(result.data.row.discount_rate);
      if (result.data.row.is_season === "Y") {
        setSeason(true);
      }
    } else {
      Swal.fire(result.data.msg);
      return;
    }
  };

  useEffect(() => {
    load_data();
  }, []);

  // 삭제하기 클릭
  const onDeleteClick = () => {
    Swal.fire({
      title: "삭제하시겠습니까?",
      showConfirmButton: true,
      showCancelButton: true,
    })
      .then(async (result) => {
        if (result.isConfirmed) {
          let result = await axios.post(
            configState.api + "/gympass_admin/item_del",
            {
              token: token,
              cid: login.cid,
              level: login.level,
              mcd: login.mcd,
              seq: seq,
            }
          );
          if (result.data.success === 1) {
            onClosePop();
          } else {
            Swal.fire(result.data.msg);
          }
        }
      })
      .catch((e) => alert(e));
  };

  return (
    <Box>
      <Box sx={{ p: 2 }}>
        {/* 상품코드 */}
        <Box
          css={css`
            margin-top: 10px;
          `}
        >
          상품코드 : {pid}
        </Box>

        {/* 상품구분 */}
        <FormControl
          css={css`
            margin-top: 10px;
          `}
        >
          <InputLabel id="demo-simple-select-label">상품구분</InputLabel>
          <Select
            name="type"
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            css={css`
              width: 260px;
            `}
            label="상품구분"
            size="small"
            value={type}
            onChange={(e) => setType(e.target.value)}
          >
            <MenuItem value="CLASS">클래스쿠폰</MenuItem>
            <MenuItem value="PT_TRAINER">PT트레이너쿠폰</MenuItem>
            <MenuItem value="PT_MANAGER">PT점장쿠폰</MenuItem>
            <MenuItem value="PASS">패스쿠폰</MenuItem>
          </Select>
        </FormControl>

        {/* 상품명 */}
        <Box mt={2} width={400}>
          <TextField
            fullWidth
            name="name"
            label="상품명"
            size="small"
            autoComplete="off"
            value={name}
            onChange={(e) => setName(e.target.value)}
          ></TextField>
        </Box>

        {/* 소비자가 */}
        <FormControl
          fullWidth
          css={css`
            margin-top: 10px;
          `}
        >
          <TextField
            name="origin_price"
            label="소비자가"
            size="small"
            autoComplete="off"
            value={originPrice}
            onChange={(e) => setOriginPrice(e.target.value)}
            sx={{ width: 180 }}
          ></TextField>
        </FormControl>

        {/* 판매가 */}
        <FormControl
          fullWidth
          css={css`
            margin-top: 10px;
          `}
        >
          <TextField
            name="amount"
            label="판매가"
            size="small"
            autoComplete="off"
            value={amount}
            onChange={(e) => setAmount(e.target.value)}
            sx={{ width: 180 }}
          ></TextField>
        </FormControl>

        {/* 할인율 */}
        <FormControl
          fullWidth
          css={css`
            margin-top: 10px;
          `}
        >
          <TextField
            name="discount_rate"
            label="할인율"
            size="small"
            autoComplete="off"
            value={discountRate}
            sx={{ width: 180 }}
            InputProps={{
              endAdornment: <InputAdornment position="end">%</InputAdornment>,
            }}
            disabled
          ></TextField>
        </FormControl>

        {/* 수량 */}
        <FormControl
          fullWidth
          css={css`
            margin-top: 10px;
          `}
        >
          <TextField
            name="count"
            label="수량"
            size="small"
            autoComplete="off"
            value={count}
            sx={{ width: 180 }}
            onChange={(e) => setCount(e.target.value)}
          ></TextField>
        </FormControl>

        {/* 기간구분 */}
        <FormControl
          css={css`
            margin-top: 10px;
          `}
        >
          <InputLabel id="demo-simple-select-label">기간구분</InputLabel>
          <Select
            sx={{ width: 100 }}
            name="dtype"
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            label="기간구분"
            size="small"
            value={dtype}
            onChange={(e) => setDtype(e.target.value)}
          >
            <MenuItem value="1">일</MenuItem>
            <MenuItem value="2">개월</MenuItem>
          </Select>
        </FormControl>

        {/* 기간 */}
        <FormControl
          fullWidth
          css={css`
            margin-top: 10px;
          `}
        >
          <TextField
            name="dcount"
            label="기간"
            size="small"
            autoComplete="off"
            value={dcount}
            sx={{ width: 180 }}
            onChange={(e) => setDcount(e.target.value)}
          ></TextField>
        </FormControl>

        {/* 노출 */}
        <FormControl
          css={css`
            margin-top: 10px;
          `}
        >
          <InputLabel id="demo-simple-select-label1">노출</InputLabel>
          <Select
            name="is_show"
            labelId="demo-simple-select-label1"
            css={css`
              width: 100px;
            `}
            label="노출"
            size="small"
            value={is_show}
            onChange={(e) => setIsShow(e.target.value)}
          >
            <MenuItem value="">노출</MenuItem>
            <MenuItem value="1">비노출</MenuItem>
          </Select>
        </FormControl>

        {/* 정기권 */}
        <div style={{ marginTop: 10 }}>
          <label htmlFor="season">
            <input
              id="season"
              type="checkbox"
              value="Y"
              checked={season}
              onChange={(e) => setSeason(e.target.checked)}
            ></input>{" "}
            정기권 (쿠폰차감없음)
          </label>
        </div>

        <Box
          css={css`
            text-align: center;
            margin-top: 30px;
          `}
        >
          <Button variant="contained" onClick={onSubmit}>
            수정완료
          </Button>
          <Button
            variant="contained"
            color="primary"
            css={css`
              margin-left: 10px;
            `}
            onClick={onClosePop}
          >
            취소
          </Button>

          <Button
            variant="contained"
            color="warning"
            css={css`
              margin-left: 10px;
            `}
            onClick={onDeleteClick}
          >
            삭제
          </Button>
        </Box>
      </Box>
    </Box>
  );
}

export default ItemEdit;
